import { PLAN_KINDS } from '@/modules/account'
import type { Plan } from '../stores/types'

const dollars = (cents: number) =>
  (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

export const isSingleProject = (plan: Plan) =>
  plan.kind === PLAN_KINDS.single_project

export const formatOneTimePrice = (plan: Plan) => dollars(plan.unitAmount)

export const formatCredits = (plan: Plan) =>
  plan.pagesCreditGrant.toLocaleString('en-US')

export const singleProjectPlan = (plans: Plan[]) => plans.find(isSingleProject)
